import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UISelect from 'UIComponents/input/UISelect';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const FILTER_STYLE = 'filter';
export const FORM_STYLE = 'form';
const BASE_EMAIL_TYPE_FILTERS = ['automated', 'batch', 'blog', 'followup', 'ab', 'automatedAb', 'rss', 'timezone'];
export default class EmailTypeSelect extends Component {
  constructor(...args) {
    super(...args);
    this.onChange = e => {
      this.props.onChange(e.target.value);
    };
  }
  getTypeFilters() {
    return BASE_EMAIL_TYPE_FILTERS.map(type => ({
      value: type,
      key: `EmailComponents.filters.emailTypeSelect.values.${type}`
    }));
  }
  getOptions() {
    const {
      options: inputOptions
    } = this.props;
    const options = inputOptions || this.getTypeFilters();
    return options.map(option => Object.assign({}, option, {
      text: I18n.text(option.key)
    })).sort((a, b) => a.text > b.text ? 1 : -1);
  }
  render() {
    const {
      ButtonContent,
      disabled,
      hubspotOutageFilter,
      isUseInFramework,
      labelKey,
      multi,
      use,
      value,
      shouldShowLabel,
      defaultOpen,
      margin
    } = this.props;
    const isFilterView = use === FILTER_STYLE;
    const options = this.getOptions();
    return /*#__PURE__*/_jsx(InlineLabel, {
      margin: margin,
      label: shouldShowLabel && isFilterView && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: labelKey || EmailTypeSelect.defaultProps.labelKey
      }),
      children: /*#__PURE__*/_jsx(UISelect, {
        ButtonContent: ButtonContent,
        anchorType: multi ? 'button' : 'auto',
        buttonUse: isFilterView ? 'transparent' : 'form',
        className: isFilterView ? 'compact-select' : undefined,
        clearable: true,
        "data-test-id": "email-type-selector",
        disabled: disabled || options.length === 0,
        defaultOpen: defaultOpen,
        menuWidth: "auto",
        minimumSearchCount: 5,
        multi: multi,
        onChange: this.onChange,
        options: options,
        placeholder: isUseInFramework ? I18n.text('EmailComponents.filters.emailTypeSelect.prefixes.allEmailTypesFramework') : I18n.text('EmailComponents.filters.emailTypeSelect.prefixes.allEmailTypes'),
        value: hubspotOutageFilter ? I18n.text('EmailComponents.filters.emailTypeSelect.values.outageFilter') : value
      })
    });
  }
}
EmailTypeSelect.propTypes = {
  ButtonContent: PropTypes.func,
  disabled: PropTypes.bool,
  hubspotOutageFilter: PropTypes.bool,
  isUseInFramework: PropTypes.bool,
  labelKey: PropTypes.string,
  margin: PropTypes.string,
  multi: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  use: PropTypes.oneOf([FILTER_STYLE, FORM_STYLE]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  shouldShowLabel: PropTypes.bool,
  defaultOpen: PropTypes.bool
};
EmailTypeSelect.defaultProps = {
  className: '',
  labelKey: 'EmailComponents.filters.emailTypeSelect.prefixes.type',
  multi: false,
  use: 'filter',
  shouldShowLabel: true
};